import React from "react";
import { Link } from "react-router-dom";
import { Star, Quote, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TESTIMONIALS } from "@/data/mock";

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page" className="bg-brand-bgTerracottaSoft">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12">
        <p className="text-xs uppercase tracking-[0.22em] text-brand-terracotta font-medium">
          Reviews
        </p>
        <h1 className="mt-4 font-display text-5xl md:text-7xl font-semibold tracking-tighter leading-[0.95] text-brand-ink max-w-4xl text-balance">
          What the neighbours are saying.
        </h1>
        <p className="mt-6 text-lg text-brand-inkSoft max-w-2xl">
          Every review verified, every reviewer real. Most of them within a 30-minute drive of our
          yard.
        </p>
        <div className="mt-8 inline-flex items-center gap-3 rounded-full border border-brand-line bg-white px-5 py-3">
          <div className="flex items-center gap-1 text-brand-ochre">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-current" />
            ))}
          </div>
          <span className="text-sm text-brand-ink font-medium">4.9 / 5 average · 180+ reviews</span>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-20 md:pb-28">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <article
              key={t.name}
              data-testid={`testimonial-${t.name}`}
              className="rounded-3xl border border-brand-line bg-white p-7 hover:bg-white transition-colors"
            >
              <Quote className="w-7 h-7 text-brand-terracotta" />
              <p className="mt-5 font-display text-lg leading-relaxed text-brand-ink">
                “{t.quote}”
              </p>
              <div className="mt-7 pt-5 border-t border-brand-line flex items-center justify-between">
                <div>
                  <p className="font-medium text-brand-ink">{t.name}</p>
                  <p className="text-sm text-brand-inkSoft">{t.project}</p>
                </div>
                <div className="flex items-center gap-0.5 text-brand-ochre">
                  {[...Array(t.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-current" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="border-t border-brand-line bg-brand-bgSageSoft">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight text-brand-ink max-w-xl">
            Be our next happy neighbour.
          </h2>
          <Button
            asChild
            data-testid="testimonials-cta"
            className="rounded-full h-12 px-7 bg-brand-terracotta hover:bg-brand-terracottaDark text-white self-start md:self-auto"
          >
            <Link to="/contact">
              Get a free quote <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
